import useTranslation from '../../hooks/useTranslation';

import { formatToUSDate } from '@@utils/dateTimeUtils/dateFormatUtil';
import { HorizontalContainer, VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import StatusPill from 'components/StatusPill';

import { SOURCE_PILL_VARIANT, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const FormulationCurrentSummary: FunctionComponent<Props> = ({
    className = '',
    current,
    testId = TEST_ID
}) => {
    const t = useTranslation();
    const { agrianFormulation, formulationCode, source, verification } = current;
    const sourceText = {
        AGRIAN: t.AGRIAN_SOURCE,
        UNKNOWN: t.UNKNOWN_SOURCE,
        VERIFIED: t.VERIFIED_SOURCE
    }[source];
    const codeText = [formulationCode ?? t.UNKNOWN, agrianFormulation]
        .filter(Boolean)
        .join(t.SOURCE_SEPARATOR);

    return (
        <VerticalContainer
            className={`${styles.formulationCurrentSummary} ${className}`}
            testId={testId}>
            <Wrapper className={styles.label}>{t.CURRENT_FORMULATION}</Wrapper>

            <HorizontalContainer className={styles.codeRow}>
                <Wrapper className={styles.code}>{codeText}</Wrapper>

                <StatusPill text={sourceText} variant={SOURCE_PILL_VARIANT[source]} />
            </HorizontalContainer>

            {verification && (
                <VerticalContainer className={styles.verification}>
                    <Wrapper className={styles.evidence}>{verification.evidence}</Wrapper>

                    {verification.labelMixingNote && (
                        <Wrapper className={styles.meta}>{verification.labelMixingNote}</Wrapper>
                    )}

                    <Wrapper className={styles.meta}>
                        {t.verifiedOn(formatToUSDate(new Date(verification.verifiedAt)))}
                    </Wrapper>
                </VerticalContainer>
            )}
        </VerticalContainer>
    );
};

export default FormulationCurrentSummary;
